<div class="ajax-loading ajax-popup-loading"><div class="loading-icon"></div></div>
<div class="mat-dialog-title" mat-dialog-title="">
    <h2>{{group.groupId != null && group.groupId.length > 0 ? "Edit Configuration Group" : "Add Configuration Group"}}</h2>
    <button mat-button mat-dialog-close class="close">Cancel</button>
</div>

<div class="model-dailog-body">
    <form (ngSubmit)="saveProduct()">
        <div mat-dialog-content class="example-container">
            <div class="row m-t-10">
                <div class="col-md-12">
                    <mat-form-field>
                        <input matInput type="text" maxlength="5" placeholder="Code"
                                [formControl]="productCode" name="code" [(ngModel)]="group.productCode" />
                        <mat-error *ngIf="productCode.invalid">Product Code is required</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-12">
                    <mat-form-field>
                        <textarea matInput type="text" maxlength="2000" placeholder="Description"
                                [formControl]="groupName" name="description" [(ngModel)]="group.groupName"></textarea>
                        <mat-error *ngIf="groupName.invalid">Group name is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
           
        </div>
        <div mat-dialog-actions class="row">
            <div class="col-12">
                <div class="text-center pt-3 pb-4 d-flex  justify-content-center">
                    <button mat-raised-button color="primary" type="submit" class="oms-btn me-3">Save </button>&nbsp;&nbsp;
                    <button mat-raised-button color="primary" (click)="closeDialog()" type="button" class="oms-btn-primary">Cancel </button>
                </div>
            </div>
        </div>
    </form>
</div>

